import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appSetTextColor]'
})
export class SetTextColorDirective {
  @Input('appSetTextColor') textColor: string;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    if(this.textColor)
      this.el.nativeElement.style.color = this.textColor;
  }
}
